import { createNav, bindNav } from "./components/Nav.js";
import { createFooter } from "./sections/Footer.js";
import { createSignupHeroSection } from "./sections/signup/SignupHero.js";
import { createSignupFormSection } from "./sections/signup/SignupForm.js";
import { getSignupPage, signupRoute } from "../config/signupContent.js";

export function mountSignupPage(root) {
  const pageContent = getSignupPage();

  const canvasLayer = document.createElement("div");
  canvasLayer.className = "canvas-layer";
  canvasLayer.innerHTML = `<canvas id="canvas" aria-hidden="true"></canvas>`;

  const contentLayer = document.createElement("div");
  contentLayer.className = "content-layer content-layer--signup";

  const nav = createNav();

  contentLayer.append(
    nav,
    createSignupHeroSection(),
    createSignupFormSection(),
    createFooter()
  );

  root.append(canvasLayer, contentLayer);

  const updateNavActive = bindNav(nav, {
    page: "signup",
    sectionMap: {
      hero: signupRoute("hero"),
      register: signupRoute("register"),
    },
  });

  return {
    canvas: canvasLayer.querySelector("#canvas"),
    updateNavActive,
    documentTitle: pageContent.documentTitle,
    sections: {
      hero: contentLayer.querySelector("#hero"),
      register: contentLayer.querySelector("#register"),
    },
  };
}
